// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4975":"css/admin-app.6960","5947":"css/app.6960"}[chunkId] + ".css";
};